









import { Component, Prop, Vue } from 'vue-property-decorator';
import { HeaderLink } from '@/types/header';

@Component({})
export default class Header extends Vue {
  @Prop({ default: 'Portal' }) title!: string;
  @Prop({ default: () => [] }) links!: HeaderLink[];
}
